export class EmployeeDocumentNode {
  Id: number;
  EmployeeId: number;
  FileName: string;
  OriginalFileName: string;
  MimeType: string;
  Size: number;
  Path: string;
  FileType: string;
  IsPrivateDocument: boolean;
  Status: string;
  CreatedBy: {
    Id: number;
    Name: string;
  };
  CreatedOn: string;
  ModifiedBy: {
    Id: number;
    Name: string;
  };
  ModifiedOn: string;
}

export class EmployeeDocumentUploadable {
  Id: number;
  EmployeeId: number;
  FileName: string;
  OriginalFileName: string;
  MimeType: string;
  Size: number;
  Path: string;
  FileType: string;
  IsPrivateDocument: boolean;
  Status: string;
  CreatedBy: number;
  CreatedOn: string;
  ModifiedBy: number;
  ModifiedOn: string;
}

export class PrivateDocumentListBase {
  Id: number;
  Filename: string | null;
  Path: string | null;
  CreatedOn: string | null;
  TrainedById: number | null;
  TrainedOn: string | null;
  DocumentType: string | null;
}

export class PrivateDocumentListResponse extends PrivateDocumentListBase {
  ApprovedOn: string | null;
  CreatedBy: string | null;
}

export class PrivateDocumentUploadListResponse extends PrivateDocumentListBase {
  EmployeeId: number;
}

export class EmployeeApprovalDocument {
  EmployeeId: number;
  EmployeeName: string;
  TotalDocuments: number;
  TotalApprovedDocuments: number;
  EmployeeDocuments: PrivateDocumentListResponse[];
  ApprovedStatus: string;
  TypeOfEmployee: string;
  BusinessName: string;
  DepartmentName: string;
  BusinessDepartmentIds: number[];
}

/** Documents per page in the single-employee documented-training list. */
export const DOCUMENTED_TRAINING_PAGE_SIZE = 25;

/** The most documents the documented-training endpoint returns in one page. */
export const DOCUMENTED_TRAINING_MAX_PAGE_SIZE = 100;

/**
 * One page of an employee's documented-training documents. The documents are camelCase, the
 * shape the document explorer reads.
 */
export interface DocumentedTrainingPage {
  items: any[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}
